/**
 * @generated SignedSource<<9f143af2d72ff8a7ec597072d2b48f75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedVisuallySimilarItemsCarousel_item$data = {
  readonly isArt: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedVisuallySimilarItemsCarousel_item";
};
export type PdpSharedVisuallySimilarItemsCarousel_item$key = {
  readonly " $data"?: PdpSharedVisuallySimilarItemsCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarousel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedVisuallySimilarItemsCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2f84ef55e7b717abd01871b16d952d2d";

export default node;
